import { forwardRef } from 'react';
import { Box, CircularProgressProps } from '@mui/material';

import mixinSx from '@watershed/style/mixinSx';

import CircularProgress from './CircularProgress';

export default forwardRef(function CenteredCircularProgress(
  { sx, ...props }: Omit<CircularProgressProps, 'style' | 'ref'>,
  ref: React.Ref<HTMLDivElement>
) {
  return (
    <Box
      component="div"
      sx={mixinSx(
        {
          display: 'flex',
          position: 'absolute',
          inset: 0,
          justifyContent: 'center',
          alignItems: 'center',
        },
        sx
      )}
      ref={ref}
    >
      <CircularProgress {...props} />
    </Box>
  );
});
